<div class="container">
    <div class="message">
        {{data.message}}
    </div>

    <mat-icon
        style="cursor: pointer; color: #ffffff"
        (click)="snackBarRef.dismiss()"
        >close</mat-icon
    >
</div>
